<!-- 返佣账号信息 -->
<style lang="scss" scoped>
.rebate-account-info-wrapper {
  background: #ffffff;
  padding: 20px;
}

.footer {
  text-align: end;
  margin-top: 20px;
}
</style>

<template>
  <div class="rebate-account-info-wrapper mt-24px">
    <el-form ref="formRef" :model="form" :rules="rules" label-position="top" label-width="90px">
      <div class="g-title">返佣账户信息</div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="账户名称" prop="accountName">
            <el-input v-model="accountName" disabled placeholder="请输入账户名称" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="银行卡号" prop="rebateBankAccount">
            <el-input v-model="form.rebateBankAccount" type="number" placeholder="请输入银行卡号" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户行名称" prop="rebateBankName">
            <el-input v-model="form.rebateBankName" placeholder="请输入开户行名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户行行号" prop="rebateBankCode">
            <el-input v-model="form.rebateBankCode" type="number" placeholder="请输入开户行行号" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 仅企业身份入驻且入驻城市合伙人时展示 -->
      <template v-if="form.companyType === 1 && form.corpType === JOIN_TYPE_ENUM.CITY_PARTNER.value">
        <div class="g-title">发票信息（用于开具加盟费相关费用发票）</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开户名称" prop="corpName">
              <el-input v-model="form.corpName" disabled placeholder="请输入开户名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码" prop="companyCreditCode">
              <el-input v-model="form.companyCreditCode" disabled placeholder="请输入统一社会信用代码" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行账号" prop="invoiceBankAccount">
              <el-input v-model="form.invoiceBankAccount" type="number" placeholder="请输入银行账号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行号" prop="invoiceBankCode">
              <el-input v-model="form.invoiceBankCode" type="number" placeholder="请输入开户行号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="invoicePhone">
              <el-input v-model="form.invoicePhone" type="number" placeholder="请输入联系方式" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址" prop="invoiceAddress">
              <el-input v-model="form.invoiceAddress" placeholder="请输入地址" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </el-form>
  </div>
  <div class="footer">
    <el-button size="large" @click="cancel">取消</el-button>
    <el-button size="large" @click="prevStep">上一步</el-button>
    <el-button type="primary" size="large" @click="submit">下一步</el-button>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { JOIN_TYPE_ENUM } from '@/constants/common'
import userApi from '@/apis/user'
// import { isPhone } from '@/common/js/validator'

const form = ref({
  corpName: '', //账户名称
  rebateBankAccount: '', //银行卡号
  rebateBankName: '', //开户行名称
  rebateBankCode: '', //开户行行号
  companyCreditCode: '', //统一社会信用代码
  invoiceBankAccount: '', //银行账号
  invoiceBankCode: '', //开户行号
  invoicePhone: '', //联系方式
  invoiceAddress: '', //地址
})

//账户名称
const accountName = computed(() => {
  return form.value.companyType === 1 ? form.value.corpName : form.value.legalName
})

const props = defineProps({
  close: {
    type: Function,
    default: () => {},
  },
  prevStep: {
    type: Function,
    default: () => {},
  },
  nextStep: {
    type: Function,
    default: () => {},
  },
  joinData: {
    type: Object,
    default: () => {},
  },
  setJoinData: {
    type: Function,
    default: () => {},
  },
})

watch(
  () => form.value,
  (newVal) => {
    //更新joinData数据
    props.setJoinData(newVal)
  },
  { deep: true },
)

// 自定义手机号码验证规则
// const checkPhone = (rule, value, callback) => {
//   if (!value) {
//     return callback(new Error('请输入联系方式'))
//   }
//   if (!isPhone(value)) {
//     return callback(new Error('输入手机号码格式不对'))
//   }
//   callback()
// }

const rules = ref({
  rebateBankAccount: [{ required: true, message: '请输入银行卡号', trigger: 'blur' }],
  rebateBankName: [{ required: true, message: '请输入开户行名称', trigger: 'blur' }],
  // rebateBankCode: [{ required: true, message: '请输入开户行行号', trigger: 'blur' }],
  companyCreditCode: [{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' }],
  //invoiceBankAccount: [{ required: true, message: '请输入银行账号', trigger: 'blur' }],
  //invoiceBankCode: [{ required: true, message: '请输入开户行号', trigger: 'blur' }],
  //invoicePhone: [{ required: true, validator: checkPhone, trigger: ['blur', 'change'] }],
  //invoiceAddress: [{ required: true, message: '请输入地址', trigger: ['blur', 'change'] }],
})

onMounted(() => {
  Object.assign(form.value, props.joinData)
})

const cancel = () => {
  props.close()
}
const prevStep = () => {
  props.prevStep()
}

const formRef = ref(null)
const submit = async () => {
  try {
    await formRef.value.validate()

    //更新joinData数据
    props.setJoinData(form.value)

    //组装接口需要的数据格式
    const params = setParams()

    await userApi.postPartnerJoin(params)

    ElMessage.success('提交成功')

    props.nextStep()
  } catch (error) {
    console.log(error)
  }
}

const setParams = () => {
  const { mobile, corpName, corpType, legalName, companyType, corpProvinceCode, corpProvinceName, corpCityCode, corpCityName } = form.value
  //需要移除的字段集合
  const removeFields = [
    'rebateAccountName',
    'rebateBankAccount',
    'rebateBankCode',
    'rebateBankName',
    'invoiceAddress',
    'invoiceBankAccount',
    'invoiceBankCode',
    'invoicePhone',
  ]
  const params = {
    mobile,
    corpName: form.value.companyType === 1 ? corpName : legalName,
    corpType,
    companyType,
    corpProvinceCode,
    corpProvinceName,
    corpCityCode,
    corpCityName,
    corpCode: companyType === 1 ? form.value.companyCreditCode : form.value.legalIdentityCard, //个人是身份证号，企业是统一社会信用代码
    corpOpenInfo: form.value,
    rebateInfo: {
      rebateBankAccount: form.value.rebateBankAccount, //返佣银行卡号
      rebateBankName: form.value.rebateBankName, //返佣开户行名称
      rebateBankCode: form.value.rebateBankCode, //返佣开户行行号
      rebateAccountName: form.value.companyType === 1 ? corpName : legalName, //返佣人名称
    },
    invoiceInfo: {
      invoiceBankAccount: form.value.invoiceBankAccount, //开具发票的银行账号
      invoiceBankCode: form.value.invoiceBankCode, //开具发票的银行行号
      invoiceAddress: form.value.invoiceAddress, //开具发票的联系地址
      invoicePhone: form.value.invoicePhone, //开具发票的联系方式
      invoiceTaxName: corpName, //开具发票的名称
      invoiceTaxCode: form.value.companyCreditCode, //开具发票的税号
    },
  }
  //剔除不需要的字段
  const data = JSON.parse(JSON.stringify(params))
  removeFields.forEach((key) => {
    delete data.corpOpenInfo[key]
  })
  return data
}
</script>
